var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4883 6.29417V8.6275C10.4883 8.77917 10.4825 8.925 10.465 9.065C10.3308 10.64 9.40334 11.4217 7.69417 11.4217H7.46084C7.31501 11.4217 7.175 11.4917 7.0875 11.6083L6.38751 12.5417C6.07834 12.9558 5.57667 12.9558 5.2675 12.5417L4.56749 11.6083C4.49166 11.5092 4.3225 11.4217 4.19417 11.4217H3.96084C2.1 11.4217 1.16667 10.9608 1.16667 8.6275V6.29417C1.16667 4.585 1.95417 3.6575 3.52334 3.52334C3.66334 3.50584 3.80917 3.5 3.96084 3.5H7.69417C9.555 3.5 10.4883 4.43334 10.4883 6.29417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8217 3.96084V6.29417C12.8217 8.00917 12.0342 8.93084 10.465 9.065C10.4825 8.925 10.4883 8.77917 10.4883 8.6275V6.29417C10.4883 4.43334 9.555 3.5 7.69417 3.5H3.96084C3.80917 3.5 3.66334 3.50584 3.52334 3.52334C3.6575 1.95417 4.58501 1.16667 6.29417 1.16667H10.0275C11.8883 1.16667 12.8217 2.1 12.8217 3.96084Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M13.25 0.75V13.25H0.75V0.75H13.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.87238 7.72917H7.87763",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.83071 7.72917H5.83596",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.78904 7.72917H3.79429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.cae0eb13b1072e4af825831102221679.svg";
export { ForwardRef as ReactComponent };